import notice from "./notice";
import common from "./common";
import tools from "./tools";
import app from "./app";
import Qs from "qs";
import axios from "axios";

axios.defaults.withCredentials = true
const CancelToken = axios.CancelToken;
function request(params) {
  if (!params.url && !params.href) return;
  // if (common.isApp && tools.ios) {
  //   app.deviceready(function() {
  //     if (navigator.general.un_registerScheme) {
  //       navigator.general.un_registerScheme();
  //     }
  //   });
  // }
  return new Promise((resolve, reject) => {
    let data = getParams(params);
    var root = common.ajaxRoot;
    let headers =
      params.headers ||
      {
        // "Content-Type": "application/json;charset=UTF-8"
      };
    const method = (params.type || "POST").toUpperCase();
    if (params.href) {
      params.url = params.href;
      root = "";
    }
    if(params.apiPermissionCode){
      headers == ""?headers = {}:'';
      headers.apiPermissionCode = params.apiPermissionCode;
    }
    var token = localStorage.jzy_token;
    // token = 'eyJhbGciOiJIUzUxMiJ9.eyJzdWIiOiJ7XCJlbmFibGVGbGFnXCI6XCIxXCIsXCJmaXJzdExvZ2luXCI6XCIwXCIsXCJncm91cElkXCI6MTM2Mzc4NDc2MDQxMjI1ODMwNixcImljb25cIjpcImh0dHBzOi8vYWdlbmN5LWFwaS53dHM5OTk5Lm5ldC91cGxvYWQvMjAyMTA4MTkvMTYyOTM1OTIzNzMzMjM5ODcyOS5qcGdcIixcIm5pY2tuYW1lXCI6XCLkuZ3lt57kuovlsL3nn6VcIixcIm9yZ2FuaXphdGlvbklkXCI6MTM0OTU2NjgxNzIzMjIxNjA2NixcInBhc3N3b3JkXCI6XCJ2Ml9iOGUxOGJlZTZjNmI0ZDcwNTZkNjY4Y2FjYjM4ZDI1NlwiLFwicHJpdmFjeUNvbmZpcm1cIjpcIjBcIixcInF1YWxpZmljYXRpb25GbGFnXCI6XCIxXCIsXCJ0ZW5hbnRJZFwiOjEzNDk1NjY4MTcwNzI4MzI1MTQsXCJ1c2VySWRcIjoxMzYzNzg0ODcyMzY2NjIwNjc0LFwidXNlcm5hbWVcIjpcIjE3NzAwMDAwMDAwXCJ9IiwiY3JlYXRlZCI6MTYyOTgwMTg5NTk2NywiZXhwIjoxNjMwNDA2Njk1fQ.4YS573m5hKLkPnlNZh0sstJjE79Ru3ehZi-rw4wXodiFcZw54gXks-CjPqFg4W1WQuhGB9nA6ju-Iot6nGKEHw'
    if (token) {
      headers["token"] = token;
    }
    if (common.token) {
      headers["token"] = common.token;
    }
    // if (common.isApp && tools.ios) {
    //   console.log("ios...");
    //   return app.deviceready(function() {
    //     console.log("device ready...");
    //     return navigator.general.httpRequest(
    //       [
    //         root + params.url,
    //         method,
    //         headers,
    //         method === "GET" || method === "DELETE" ? data : {},
    //         method === "POST" || method === "PUT" ? data : {} //serializer: 1 序列化 Content-Type: application/x-www-form-urlencoded   2 json  application/json;charset=UTF-8
    //       ],
    //       function(res) {
    //         res = res ? JSON.parse(res) : {};
    //         let isErr = hasError(res, params);
    //         if (isErr) {
    //           return reject(res);
    //         } else {
    //           return resolve(res);
    //         }
    //       },
    //       function(err) {
    //         return reject(err);
    //       }
    //     );
    //   });
    // }
    return axios({
      method: method,
      url: params.url,
      data: method === "POST" || method === "PUT" ? data : null,
      params: method === "GET" || method === "DELETE" ? data : null,
      baseURL: root,
      headers: headers,
      onUploadProgress: params.onUploadProgress,
      cancelToken: new CancelToken(function executor(c) {
        tools.$httpRequestList.push(c);
        tools.$httpRequestList=tools.$httpRequestList.slice(-10);//只保留最新的10个请求
      }),
      /**end */
      withCredentials: true
    })
      .then(function(res) {
        if (params.hideAlert) {
          resolve(res.data);
          return;
        }
        let isErr = hasError(res.data, params);
        if (isErr) {
          reject(res.data);
        } else {
          resolve(res.data);
        }
      })
      .catch(function(err) {
        let res = err.response;
        reject(err);
        if (!res) {
          return;
        }
        if(res.status == 503) {
          notice.alert('当前请求人数过多,请稍后再试');
        }else{
          window.alert("api error, HTTP CODE: " + res.status);
        }
      });
  });
}

// 接口参数校验和转换
function getParams(params) {
  let result;
  if (params.data) {
    result = filterNull(params.data);
  }
  if (params.contentType == "from") {
    result = getURLSearchParams(result);
  }
  return result;
}

//公共错误处理
function hasError(data, params) {
  if (data.httpCode != 1) {
    const whiteUrl = ["/api/user/loginByMobile", "/api/user/loginByCode"];
    if (whiteUrl.indexOf(params.url) == -1) {
      //不在白名单中
      if (data.httpCode == 40400 || data.httpCode == 40408) {
        console.log("登录失效", params.url, data);
        // if (common.env != 2) {
        // notice.alert(data.msg||"请重新登录", "确认", () => {
        //   tools.outLogin();
        // });
        if(common.isApp) {
          app.checkAccount();
        } else {
          tools.outLogin();
        }
        // }else{
        //   alert("登录失效")
        // }
        return true;
      }
    }
    setLayer(data.msg);
    document.getElementById("lz-readys").style.display = "none";
    return true;
  }
  return false;
}

function setLayer(msg) {
  notice.alert(msg);
}
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase();
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key];
    }
    if (toType(o[key]) === "string") {
      o[key] = o[key].trim();
    } else if (toType(o[key]) === "object") {
      o[key] = filterNull(o[key]);
    } else if (toType(o[key]) === "array") {
      o[key] = filterNull(o[key]);
    }
  }
  return o;
}
// 表单提交字段转换
function getURLSearchParams(params) {
  let data = Qs.stringify(params);
  return data;
}

export default request;
